<template>
  <div class="dashboard">
    <h2>回调限制配置</h2>
    <el-card shadow="hover" class="main-card">
      <!-- 功能区 -->
      <div class="toolbar">
        <el-input
          v-model="searchKeyword"
          placeholder="搜索渠道/广告主"
          style="width: 300px; margin-right: 20px"
          clearable
        />
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">
          新增配置
        </el-button>
      </div>

      <!-- 数据表格 -->
      <el-table :data="filteredData" border style="margin-top: 20px">
        <el-table-column prop="src" label="渠道" width="180" />
        <el-table-column prop="target" label="广告主" width="180" />
         <el-table-column label="回调设置">
          <template slot-scope="{ row }">
            <div class="param-container">
              <el-tag
                v-for="(item, key) in row.data"
                :key="key"
                type="info"
              >
                <span class="param-label">返回码</span> {{ item.key }} 
                <span class="param-label">回调比例</span> {{ item.value }}
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="240">
            <template slot-scope="{ row, $index }">
                <div class="action-buttons">
                <!-- 编辑按钮 -->
                <el-button
                    type="primary"
                    plain
                    icon="el-icon-edit"
                    class="custom-btn"
                    @click="handleEdit(row, $index)"
                >
                    编辑
                </el-button>
                
                <!-- 删除按钮 -->
                <el-button
                    type="danger"
                    plain
                    icon="el-icon-delete"
                    class="custom-btn"
                    @click="handleDelete(row)"
                >
                    删除
                </el-button>
                </div>
            </template>
        </el-table-column>
      </el-table>

      <!-- 编辑对话框 -->
      <el-dialog
        :title="isEdit ? '编辑配置' : '新增配置'"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="600px"
      >
        <el-form :model="currentItem" label-width="100px">
          <el-form-item label="渠道"  required>
            <el-input v-no-space v-model="currentItem.src" :disabled="isEdit" />
          </el-form-item>
          <el-form-item label="广告主" required>
            <el-input v-no-space v-model="currentItem.target" :disabled="isEdit" />
          </el-form-item>
          <el-form-item label="回调参数">
            <div
              v-for="(item, index) in currentItem.data"
              :key="index"
              class="param-row"
            >
              <el-input
                v-no-space
                v-model="item.key"
                placeholder="返回码"
                style="width: 200px; margin-right: 10px"
              />
              <el-input
                v-no-space
                v-model="item.value"
                placeholder="回调比例"
                style="width: 200px"
              />
              <el-button
                type="danger"
                icon="el-icon-delete"
                circle
                plain
                style="margin-left: 10px"
                @click="removeParam(index)"
              />
            </div>
            <el-button @click="addParam">
              <i class="el-icon-plus"></i>
              添加返回码配置
            </el-button>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import {GetCallTransfromLimit,AddCallTransfromLimit,UpdateCallTransfromLimit,DelCallTransfromLimit} from '../api/index'

export default {
  name: 'CallTransfromLimit',
  data() {
    return {
      searchKeyword: '',
      tableData: [],
      version:'',
      dialogVisible: false,
      isEdit: false,
      currentIndex: -1,
      currentItem: {
        src: '',
        target: '',
        data: []
      }
    }
  },
  computed: {
    filteredData() {
      return this.tableData.filter(item => {
        const keyword = this.searchKeyword.toLowerCase()
        return (
          item.src.toLowerCase().includes(keyword) ||
          item.target.toLowerCase().includes(keyword)
        )
      })
    }
  },
  created(){
    this.getList()
  },
  methods: {

    getList(){
        GetCallTransfromLimit().then(res=>{
            let newlist = []
            for(var k in res.data)
            {
                let newdata = []
                for(var i in res.data[k].data)
                {
                    newdata.push({key:i,value:res.data[k].data[i]})
                }   
                let obj = {
                    src : res.data[k].src,
                    target : res.data[k].target,
                    data : newdata
                }

                newlist.push(obj)
            }
            this.version = res.version
            this.tableData = newlist
        }).catch(err =>{
            this.$message("数据获取失败:"+err)
        })
    },

    handleAdd() {
      this.currentItem = { src: '', target: '', data: [] }
      this.isEdit = false
      this.dialogVisible = true
    },
    handleEdit(row, index) {
      this.currentItem = {
        src: row.src,
        target: row.target,
        data: row.data.map(item => ({ ...item })) // 深拷贝
      }
      this.currentIndex = index
      this.isEdit = true
      this.dialogVisible = true
    },
    handleDelete(row) {
      const key  = row.src+"2"+row.target
      console.log(row)
      DelCallTransfromLimit(key,{version:this.version}).then(()=>{
        this.getList()
        this.$message.success("删除成功")
      }).catch(()=>{
        this.$message.error("删除失败")
      })
    },
    addParam() {
      this.currentItem.data.push({ key: '', value: '' })
    },
    removeParam(index) {
      this.currentItem.data.splice(index, 1)
    },
    submitForm() {

      if(this.currentItem.src == "" || this.currentItem.target == "")
      {
        this.$message.error("渠道或产品不能为空")
        return
      }

      // 转换为Map结构存储
      const dataMap = {}
      this.currentItem.data.forEach(item => {
        if (item.key) dataMap[item.key] = parseFloat(item.value) || 0
      })

      const newItem = {
        src: this.currentItem.src,
        target: this.currentItem.target,
        data: dataMap
      }
      const key = newItem.src+"2"+newItem.target

      if (this.isEdit) {
        UpdateCallTransfromLimit(key, {...newItem, version:this.version}).then(()=>{
            this.getList()
            this.$message.success("保存成功")
        }).catch(()=>{
            this.$message.error("保存失败")
        })

        this.$set(this.tableData, this.currentIndex, newItem)
      } else {

        AddCallTransfromLimit(key, newItem).then(()=>{
            this.getList()
            this.$message.success("添加成功")
        }).catch(()=>{
            this.$message.error("添加失败")
        })
      }
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
.dashboard {
  padding: 20px;
}

.main-card {
  margin-top: 20px;
  border-radius: 8px;
}

.toolbar {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}


/* 新增样式 */
.param-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.param-label {
  color: #909399;
  margin-right: 4px;
}

.param-row {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.el-tag {
  background-color: #f4f4f5;
  border-color: #e9e9eb;
  color: #606266;
  padding: 0 10px;
  border-radius: 4px;
}

.action-buttons {
  display: flex;
  gap: 8px;
}

.custom-btn {
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 13px;
  transition: all 0.3s;
}

.el-button--primary.is-plain {
  border-color: #409eff;
  color: #409eff;
  background: #ecf5ff;
  &:hover {
    background: #409eff;
    color: white;
  }
}

.el-button--danger.is-plain {
  border-color: #f56c6c;
  color: #f56c6c;
  background: #fef0f0;
  
  &:hover {
    background: #f56c6c;
    color: white;
  }
}
</style>